module.exports = __webpack_public_path__ + "img/percent-alt.a76a8c8e.svg";